import { useFilterEvents } from '@/containers/pages/commonSettings/tabs/EventsTrailPage/useFilterEvents';
import React from 'react';
import { SearchIcon } from '@assets/icons';
import { Search } from '@components/search/search-input';
import { EventsTable } from '@/containers/pages/commonSettings/tabs/EventsTrailPage/components/EventsTable';
import { FilterTable } from '@/containers/pages/commonSettings/tabs/EventsTrailPage/components/FilterTable';
import classes from './styles.module.css';
import useEventsTrailSlice from '@/store/homeWidget/useEventsTrailSlice';
import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function EventsTrailPage() {
  const { filteredEvents } = useFilterEvents();
  const { useFilters, useIsLoading } = useEventsTrailSlice();
  const [filter, setFilter] = useFilters().useState();
  const [isLoading] = useIsLoading().useState();
  const { t } = useTranslation();

  const handleSearch = (name: string) => {
    setFilter((prev) => ({
      ...prev,
      name
    }));
  };

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <Loader color="blue" />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <Search
        style={{ width: '550px' }}
        icon={<SearchIcon />}
        className={classes.input}
        setSearch={handleSearch}
        value={filter.name}
        placeholder={t('filials.settings.searchByEvent')}
      />
      <div className={classes.content}>
        <div className={classes.title}>{t('filials.settings.eventsTitle')}</div>
        <FilterTable />
        <EventsTable events={filteredEvents} />
      </div>
    </div>
  );
}
